export default __webpack_public_path__ + "static/nearlight_logo_white-f16f795ffa9cf5dc360333461724bbae.png";